// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2025 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------

import Layout from '@/layout';
var financialRouter = {
  path: '/financial',
  component: Layout,
  redirect: '/financial/commission/template',
  name: 'Financial',
  meta: {
    title: '财务',
    icon: 'clipboard'
  },
  children: [{
    path: 'commission',
    component: function component() {
      return import('@/views/financial/index');
    },
    name: 'Commission',
    meta: {
      title: '财务操作',
      icon: ''
    },
    alwaysShow: true,
    children: [{
      path: 'template',
      component: function component() {
        return import('@/views/financial/commission/withdrawal/index');
      },
      name: 'commissionTemplate',
      meta: {
        title: '申请提现',
        icon: ''
      }
    }]
  }, {
    path: 'record',
    component: function component() {
      return import('@/views/financial/record/index');
    },
    name: 'financialRecord',
    meta: {
      title: '财务记录',
      icon: ''
    },
    alwaysShow: true,
    children: [{
      path: 'charge',
      component: function component() {
        return import('@/views/financial/record/charge/index');
      },
      name: 'Charge',
      meta: {
        title: '充值记录',
        icon: ''
      }
    }, {
      path: 'monitor',
      component: function component() {
        return import('@/views/financial/record/monitor/index');
      },
      name: 'Monitor',
      meta: {
        title: '资金监控',
        icon: ''
      }
    }]
  }, {
    path: 'brokerage',
    component: function component() {
      return import('@/views/financial/brokerage/index');
    },
    name: 'Brokerage',
    meta: {
      title: '佣金记录',
      icon: ''
    }
  }, {
    path: 'proxyPayment',
    component: function component() {
      return import('@/views/financial/proxyPayment/index');
    },
    name: 'ProxyPayment',
    meta: {
      title: '代付记录',
      icon: ''
    }
  }, {
    path: 'assetFundApplication',
    component: function component() {
      return import('@/views/financial/assetFundApplication/index');
    },
    name: 'AssetFundApplication',
    meta: {
      title: '申领/卖出审批',
      icon: ''
    }
  }, {
    path: 'bankRecharge',
    component: function component() {
      return import('@/views/financial/bankRecharge/index');
    },
    name: 'BankRecharge',
    meta: {
      title: '余额充值',
      icon: ''
    }
  }, {
    path: 'bankReceiptAccount',
    component: function component() {
      return import('@/views/financial/bankReceiptAccount/index');
    },
    name: 'BankReceiptAccount',
    meta: {
      title: '对公收款账户',
      icon: ''
    }
  }, {
    path: 'balanceAdjustment',
    component: function component() {
      return import('@/views/financial/balanceAdjustment/index');
    },
    name: 'BalanceAdjustment',
    meta: {
      title: '余额调账',
      icon: ''
    }
  }, {
    path: 'account',
    component: function component() {
      return import('@/views/financial/account/index');
    },
    name: 'AccountInfo',
    meta: {
      title: '账户信息',
      icon: ''
    }
  }]
};
export default financialRouter;